export default class ProjectTpJobEditItem {
  constructor(item) {
    if (item) {
      this.AdHocGroupEnabled = item.adHocGroupEnabled;
      this.AdHocGroup = item.adHocGroup;
      this.UninvoiceableEnabled = item.uninvoiceableEnabled;
      this.Uninvoiceable = item.uninvoiceable;
      this.PaidOutsideOfSystemEnabled = item.paidOutsideOfSystemEnabled;
      this.PaidOutsideOfSystem = item.paidOutsideOfSystem;
      this.SearchParameters = item.searchParameters;
      return;
    }

    this.AdHocGroupEnabled = false;
    this.AdHocGroup = '';
    this.UninvoiceableEnabled = false;
    this.Uninvoiceable = false;
    this.PaidOutsideOfSystemEnabled = false;
    this.PaidOutsideOfSystem = false;
    this.SearchParameters = {};
  }

  static createUninvoiceableItem() {
    return new ProjectTpJobEditItem({
      uninvoiceableEnabled: true,
      uninvoiceable: true,
    });
  }

  // CD-5421: used by the single-row action, which posts through the same bulk endpoint with one id.
  static createPaidOutsideOfSystemItem(paidOutsideOfSystem) {
    return new ProjectTpJobEditItem({
      paidOutsideOfSystemEnabled: true,
      paidOutsideOfSystem,
    });
  }
}
